function InputPlaceholder() {
    return (
        <div className={"animate-pulse xl:block bg-blue-gray-200 h-9 p-1 px-2 w-full rounded-lg"}/>
    );
}

export default InputPlaceholder;
